<template>
    <v-card dark :color="selectedExam != null ? (examValid ? 'primary' : 'error') : 'grey'">
        <v-container grid-list-md text-xs-center fluid>
            <v-layout wrap>
                <v-flex xs1 sm1 md1>
                    <span class="material-icons" v-if="selectedExam != null"> check_circle </span>
                </v-flex>

                <v-flex xs11 sm11 md8>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-list-item-subtitle v-if="selectedExam == null"> Selecione um exame </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="selectedExam != null"> Exame: {{ selectedExam.name }} </v-list-item-subtitle>
                        </div>
                    </div>
                </v-flex>

                <v-flex xs12 sm12 md3>
                    <SimpleSearch hideNew hideEdit endpoint="exams" :aditionalColumns="headersExam" @onChoose="chooseExam">
                        <template> Pesquisa de Exames </template>
                    </SimpleSearch>

                    <v-btn color="error" x-small style="width: 100%" class=" mt-12" @click="deleteItem" v-if="canDelete && selectedExam != null"> Deletar </v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
import SimpleSearch from "@/components/core/SimpleSearch";

export default {
    components: { SimpleSearch },

    props: {
        canDelete: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selectedExam: null,
            headersExam: [
                { text: "Nome", value: "name" },
                { text: "Preço", value: "price" },
            ],
        };
    },

    computed: {
        examValid() {
            return this.selectedExam && this.selectedExam.name != null;
        },
    },

    methods: {
        chooseExam(item) {
            this.selectedExam = item;
            this.$emit("onChange", this.selectedExam);
        },
        deleteItem() {
            this.selectedExam = null;
            this.$emit("onChange", this.selectedExam);
        }
    }
};
</script>